/** Own account. Content arrives in a later phase; the route exists for the chrome. */
export const PROFILE_PATH = '/profil';

/** Own inbox. Content arrives in a later phase; the route exists for the chrome. */
export const NOTIFICATIONS_PATH = '/benachrichtigungen';
